// extracted by mini-css-extract-plugin
export default {"wrapper":"ahorraSection_wrapper__xmKAm","listItemsRecarga":"ahorraSection_listItemsRecarga__V+LLb"};